<template>
  <a-drawer
      title="详情"
      @close="onClose"
      width="100%"
      :destroy-on-close="true"
      :visible="detailVisible"
      :wrapStyle="{ overflow: 'auto' }"
  >
    <a-row class="new-border" :gutter="16" style="padding-bottom: 24px;">
      <a-col class="nstyle" :lg="12" :md="12">
        <span class="detail-label">学工号：</span><span class="detail-content">{{ record.jdUserCode }}</span>
      </a-col>
      <a-col class="nstyle" :lg="12" :md="12">
        <span class="detail-label">姓名：</span><span class="detail-content">{{ record.fullName }}</span>
      </a-col>
      <a-col class="nstyle" :lg="12" :md="12">
        <span class="detail-label">所在单位：</span><span class="detail-content">{{ record.topOrganizeName }}</span>
      </a-col>
      <a-col class="nstyle" :lg="12" :md="12">
        <span class="detail-label">主办单位：</span><span class="detail-content">{{ record.organizeName }}</span>
      </a-col>
      <a-col class="nstyle" :lg="12" :md="12">
        <span class="detail-label">培训层级：</span><span class="detail-content">{{ record.pxcj }}</span>
      </a-col>
      <a-col class="nstyle" :lg="12" :md="12">
        <span class="detail-label">教育培训时间：</span><span class="detail-content">{{ record.strTime }} -  {{record.endTime}}</span>
      </a-col>
      <a-col class="nstyle" :lg="12" :md="12">
        <span class="detail-label">集中培训和集体学习学时数：</span><span class="detail-content">{{ record.pxxs }}</span>
      </a-col>
      <a-col class="nstyle" :lg="12" :md="12">
        <span class="detail-label">网络自学培训学时：</span><span class="detail-content">{{ record.wlxs }}</span>
      </a-col>
      <a-col class="nstyle" :lg="24" :md="24">
        <span class="detail-label">教育培训内容：</span><span class="detail-content">{{ record.remark }}</span>
      </a-col>
      <a-col class="nstyle" :lg="24" :md="24">
        <span class="detail-label">教育培训内容：</span><span class="detail-content">
               <fileUpload ref="fileUpload" :disabled="true" :upload="false" :file-item="record.fileUrls ? JSON.parse(record.fileUrls) : []" :size="3" />
        </span>
      </a-col>

    </a-row>

    <div
        class="zindex"
        :style="{
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
      }"
    >
      <a-button
          :style="{marginRight: '8px'}"
          @click="onClose"
      >
        返回
      </a-button>
    </div>
  </a-drawer>
</template>

<script>

import {getById} from "../../../api/educationalTraining";
import ACol from "ant-design-vue/lib/grid/Col";
import {Button, Drawer, Row} from "ant-design-vue";
import fileUpload from "./FileUpload.vue";


export default {
  name: 'Detail',
  components: {
    fileUpload, ACol ,
    'a-row': Row,
    'a-drawer': Drawer,
    'a-button': Button
  },
  props: {


  },
  data () {
    return {
      record:{},
      detailVisible: false
    }
  },
  methods: {

    show (id) {
      getById({id:id}).then(res => {
        if (res.code === 10000){
          this.record = res.result
        }
      })
      this.detailVisible = true
    },


    onClose () {
      this.detailVisible = false
    }
  }
}
</script>

<style scoped>
.nstyle{
  padding: 10px 0;
}
</style>
